import NobelWGLRegular from 'common-tridium/fonts/nobel-wgl/NobelWGL-Regular.ttf';

import NobelWGLBookEot from 'common-tridium/fonts/nobel-wgl/NobelWGL-Book.eot';
import NobelWGLBook from 'common-tridium/fonts/nobel-wgl/NobelWGL-Book.ttf';
import NobelWGLBookSvg from 'common-tridium/fonts/nobel-wgl/NobelWGL-Book.svg';
import NobelWGLBookWoff from 'common-tridium/fonts/nobel-wgl/NobelWGL-Book.woff';
import NobelWGLBookWoff2 from 'common-tridium/fonts/nobel-wgl/NobelWGL-Book.woff2';

import NobelWGLBoldEot from 'common-tridium/fonts/nobel-wgl/NobelWGL-Bold.eot';
import NobelWGLBoldWoff from 'common-tridium/fonts/nobel-wgl/NobelWGL-Bold.woff';
import NobelWGLBoldTtf from 'common-tridium/fonts/open-sans/OpenSans-Bold.ttf';
import NobelWGLBoldSvg from 'common-tridium/fonts/open-sans/OpenSans-Bold.svg';
import NobelWGLBoldWoff2 from 'common-tridium/fonts/open-sans/OpenSans-Bold.woff2';

const nobelWGLRegular = {
  fontFamily: 'NobelWGLRegular',
  fontStyle: 'normal',
  fontWeight: 400,
  src: ['local("NobelWGLRegular")', 'local("NobelWGL-Regular")', `url(${NobelWGLRegular}) format('truetype')`].join(
    ', '
  ),
};

const nobelWGLBook = {
  fontFamily: 'NobelWGLBook',
  fontStyle: 'normal',
  fontWeight: 400,
  src: [
    'local("NobelWGLBook")',
    'local("NobelWGL-Book")',
    `url(${NobelWGLBookEot}) format('embedded-opentype')`,
    `url(${NobelWGLBookWoff}) format('woff')`,
    `url(${NobelWGLBookWoff2}) format('woff2')`,
    `url(${NobelWGLBook}) format('truetype')`,
    `url(${NobelWGLBookSvg}) format('svg')`,
  ].join(', '),
};

const nobelWGLBold = {
  fontFamily: 'NobelWGLBold',
  fontStyle: 'normal',
  fontWeight: 700,
  src: [
    'local("NobelWGLBold")',
    'local("NobelWGL-Bold")',
    `url(${NobelWGLBoldEot}) format('embedded-opentype')`,
    `url(${NobelWGLBoldWoff}) format('woff')`,
    `url(${NobelWGLBoldWoff2}) format('woff2')`,
    `url(${NobelWGLBoldTtf}) format('truetype')`,
    `url(${NobelWGLBoldSvg}) format('svg')`,
  ].join(', '),
};

export const lexusFontsFaces = [nobelWGLRegular, nobelWGLBook, nobelWGLBold];
